import Loading from "../../components/common/loading";

interface WithLoaderProps {
  children: JSX.Element;
  isLoading: boolean;
}

export const WithLoader = ({ children, isLoading }: WithLoaderProps) => {
  return (
    <>
      {isLoading && <Loading />}
      {children}
    </>
  );
};
